import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkAdminStatus } from '../services/api';
import packageInfo from '../../package.json';
import VersionInfoModal from './VersionInfoModal';

function AppVersion() {
  const [clickCount, setClickCount] = useState(0);
  const [showVersionModal, setShowVersionModal] = useState(false);
  const navigate = useNavigate();
  
  const handleClick = () => {
    // Debug output
    console.log('Version clicked!');
    
    // Show version info modal on first click
    setShowVersionModal(true);
    
    // Increment click count for secret knock pattern
    const newCount = clickCount + 1;
    setClickCount(newCount);
    console.log(`Click count: ${newCount}`);
    
    // Check for secret knock pattern (5 clicks total)
    if (newCount === 5) {
      console.log('Secret knock detected! Checking admin status...');
      setClickCount(0);
      checkAdminAccess();
    }
  };
  
  const checkAdminAccess = async () => {
    try {
      console.log('Making admin check API call...');
      
      // Debug log for the request
      const token = localStorage.getItem('token');
      console.log('Using token from localStorage:', token ? 'Yes (length: ' + token.length + ')' : 'No token found');
      
      const response = await checkAdminStatus();
      console.log('Admin API response:', response);
      
      if (response.data && response.data.is_admin) {
        console.log('User is admin, navigating to admin page');
        navigate('/admin-settings');
      } else {
        console.log('User is not an admin:', response.data);
      }
    } catch (err) {
      console.error('Error checking admin status:', err);
      console.error('Error details:', {
        message: err.message,
        response: err.response ? {
          status: err.response.status,
          statusText: err.response.statusText,
          data: err.response.data
        } : 'No response',
        request: err.request ? 'Request was made' : 'No request'
      });
      
      // Check if token exists
      const token = localStorage.getItem('token');
      console.log('Token exists in localStorage:', !!token);
      if (token) {
        console.log('Token prefix:', token.substring(0, 10) + '...');
      }
    }
  };

  return (
    <>
      <span 
        onClick={handleClick}
        style={{ 
          cursor: 'pointer', 
          padding: '2px 6px', 
          display: 'inline-flex',
          alignItems: 'center',
          border: '1px solid transparent',
          borderRadius: '3px',
          fontSize: '0.85rem',
          transition: 'all 0.2s ease'
        }}
        className="version-text status-bar-version"
        data-testid="version-text"
        title="Click to view app information"
      >
        v{packageInfo.version}
      </span>
      
      <VersionInfoModal 
        show={showVersionModal}
        onHide={() => setShowVersionModal(false)}
      />
    </>
  );
}

export default AppVersion; 
